import { signal } from "@angular/core";
import { SchemaPathTree } from "@angular/forms/signals";
import { EVOwnership } from "src/models/units/unit-attributes.model";

export interface OwnershipTypeModel {
    ownershipType: EVOwnership;
    index: number;
    selected: boolean;
    displayText: string;
}

const defaultOwnershipTypes: OwnershipTypeModel[] = [    
    {
        ownershipType: EVOwnership.Selveier,
        index: EVOwnership.Selveier,
        selected: true,
        displayText: getOwnershipText(EVOwnership.Selveier),
    },
    {
        ownershipType: EVOwnership.Borettslag,
        index: EVOwnership.Borettslag,
        selected: true,
        displayText: getOwnershipText(EVOwnership.Borettslag),
    },
    {
        ownershipType: EVOwnership.Aksjeleilighet,
        index: EVOwnership.Aksjeleilighet,
        selected: true,
        displayText: getOwnershipText(EVOwnership.Aksjeleilighet),
    },
    {
        ownershipType: EVOwnership.Obl_leilighet,
        index: EVOwnership.Obl_leilighet,
        selected: false,
        displayText: getOwnershipText(EVOwnership.Obl_leilighet),
    },
];

function getOwnershipText(ownershipId: number): string {
    let text: string = EVOwnership[ownershipId];
    if (text === "Obl_leilighet") {
        text = "Obligasjonsleilighet";
    }
    return text;
}

export interface OwnershipTypesFilterModel {
    ownershipTypes: OwnershipTypeModel[];
    expanded: boolean;
}

export function createOwnershipTypesModel() {
    return signal<OwnershipTypesFilterModel>({
        ownershipTypes: defaultOwnershipTypes,
        expanded: true,
    });
}

export function buildOwnershipTypesModel(a: SchemaPathTree<OwnershipTypesFilterModel>) {}
